module.exports = __webpack_public_path__ + "img/fruit-kiwi-350x184.02ec974b.jpg";